import './App.scss';
import { Routes,Route } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Contact from './components/Contact';
import Projects from './components/Projects';
import MyResume from './components/MyResume';

function App() {
  return (
    <div className='App'>
        <Routes>
          {/* <Route path='/' element={<> <Outlet/></>}> */}
            <Route path='/' element={
            <>
              <Navbar/>
                <Home/>
              <Footer/>
            </>}/>
            <Route path='/about' element={
               <>
               <Navbar/>
                 <About/>
               <Footer/>
             </>
            }/>
              <Route path='/contact' element={
                <>
                  <Navbar/>
                    <Contact/>
                  <Footer/>
                </>
              }/>
            <Route path='/projects' element={
              <>
                <Navbar/>
                  <Projects/>
                <Footer/>
              </>
            }/>
            <Route path='/resume' element={
              <>
                <Navbar/>
                  <MyResume/>
                <Footer/>
              </>
            }/>
          {/* </Route> */}
        </Routes>
    </div>
  );
}

export default App;
